import { render, staticRenderFns } from "./App.vue?vue&type=template&id=49ea6912&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=49ea6912&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports